module.exports = __webpack_public_path__ + "static/media/Ziege.8d3f8fea.jpg";